"use client";

import { c as _c } from "react/compiler-runtime";
;
!function () {
  try {
    var e = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : {};
    e._sentryModuleMetadata = e._sentryModuleMetadata || {}, e._sentryModuleMetadata[new e.Error().stack] = Object.assign({}, e._sentryModuleMetadata[new e.Error().stack], {
      "_sentryBundlerPluginAppKey:propstrata-app": true
    });
  } catch (e) {}
}();
import { useQuery } from "@tanstack/react-query";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { ShareViewTourUnavailableDialog } from "@/features/onboarding-tours/components/share-view-tour-unavailable-dialog";
import { TourCatalogDialog } from "@/features/onboarding-tours/components/tour-catalog-dialog";
import { TourJoyrideShell } from "@/features/onboarding-tours/components/tour-joyride-shell";
import { OnboardingToursContext } from "@/features/onboarding-tours/context/onboarding-tours-context";
import { useTourSession } from "@/features/onboarding-tours/context/use-tour-session";
import { useVisualizationGuardTourSignal, VisualizationGuardTourSignalProvider } from "@/features/onboarding-tours/context/visualization-guard-tour-signal";
import { getCatalogPage } from "@/features/onboarding-tours/orchestrator/get-catalog-page";
import { deriveDataProviderObjective, resolvePersistedInvitedObjective, resolvePipelineAdvanceAction, shouldAttemptPipeline, shouldFetchWorkspaceInviteMemberCount } from "@/features/onboarding-tours/orchestrator/tour-orchestrator";
import { readOnboardingToursStorage, writeOnboardingToursStorage } from "@/features/onboarding-tours/orchestrator/tour-persistence";
import { ALL_TOUR_DEFINITIONS } from "@/features/onboarding-tours/registry/tour-registry";
import type { OnboardingToursStorageValue } from "@/features/onboarding-tours/types/tour-persistence";
import { useTierGuard } from "@/hooks/use-tier-guard";
import { useWorkspacePermissionCheck } from "@/hooks/use-workspace-permission-check";
import { useCurrentWorkspace } from "@/hooks/useCurrentWorkspace";
import { useDataProviders } from "@/hooks/useDataProviders";
import { useUserData } from "@/hooks/useUserData";
import { getWorkspaceUserCountQueryOptions } from "@/queries/workspace/fetchers";
function OnboardingToursRuntime(t0) {
  const $ = _c(101);
  const {
    children
  } = t0;
  const {
    organization,
    userData
  } = useUserData();
  const {
    workspaceId,
    workspacePermissions,
    workspace
  } = useCurrentWorkspace();
  workspace?.activeViews;
  let t1;
  if ($[0] !== workspace?.activeViews) {
    t1 = workspace?.activeViews.map(_temp) ?? [];
    $[0] = workspace?.activeViews;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const activeViewNames = t1;
  const {
    hasFullProductAccess
  } = useTierGuard();
  const {
    check
  } = useWorkspacePermissionCheck();
  const {
    isVisualizationGuardActive
  } = useVisualizationGuardTourSignal();
  const t2 = Boolean(workspaceId);
  let t3;
  if ($[2] !== t2) {
    t3 = {
      enabled: t2
    };
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const {
    dataProviders
  } = useDataProviders(t3);
  const organizationId = organization?.id;
  const userId = userData?.id;
  let t4;
  if ($[4] !== organizationId || $[5] !== userId) {
    t4 = () => organizationId && userId ? readOnboardingToursStorage({
      organizationId,
      userId
    }) : readOnboardingToursStorage({
      organizationId: "anonymous",
      userId: "anonymous"
    });
    $[4] = organizationId;
    $[5] = userId;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const [storage, setStorage] = useState(t4);
  const [catalogOpen, setCatalogOpenState] = useState(false);
  const [catalogQuery, setCatalogQuery] = useState("");
  const [catalogPage, setCatalogPage] = useState(0);
  const pipelineAttemptedRef = useRef(false);
  const canAccessProductToursCatalog = hasFullProductAccess === true;
  let t5;
  if ($[7] !== canAccessProductToursCatalog) {
    t5 = open => {
      if (!canAccessProductToursCatalog) {
        return;
      }
      setCatalogOpenState(open);
    };
    $[7] = canAccessProductToursCatalog;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const setCatalogOpen = t5;
  let t6;
  let t7;
  if ($[9] !== canAccessProductToursCatalog) {
    t6 = function closeCatalogWhenProductToursUnavailable() {
      if (!canAccessProductToursCatalog) {
        setCatalogOpenState(false);
      }
    };
    t7 = [canAccessProductToursCatalog];
    $[9] = canAccessProductToursCatalog;
    $[10] = t6;
    $[11] = t7;
  } else {
    t6 = $[10];
    t7 = $[11];
  }
  useEffect(t6, t7);
  let t8;
  if ($[12] !== check) {
    t8 = check("dataProvider", "canDelete");
    $[12] = check;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== check) {
    t9 = check("dashboards", "canEdit");
    $[14] = check;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  const t10 = Object.values(workspacePermissions ?? {}).some(_temp2);
  let t11;
  if ($[16] !== check) {
    t11 = check("users", "canCreate");
    $[16] = check;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== check) {
    t12 = check("dashboards", "canEdit") || check("dashboards", "canDelete");
    $[18] = check;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  const t13 = hasFullProductAccess === true;
  let t14;
  if ($[20] !== t10 || $[21] !== t11 || $[22] !== t12 || $[23] !== t13 || $[24] !== t8 || $[25] !== t9) {
    t14 = {
      canDeleteDataProvider: t8,
      canEditDashboards: t9,
      canEditLeaderboard: t10,
      canInvite: t11,
      canManageDashboardViews: t12,
      hasFullProductAccess: t13
    };
    $[20] = t10;
    $[21] = t11;
    $[22] = t12;
    $[23] = t13;
    $[24] = t8;
    $[25] = t9;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  const eligibilityContext = t14;
  let t15;
  if ($[27] !== activeViewNames || $[28] !== eligibilityContext || $[29] !== isVisualizationGuardActive || $[30] !== organizationId || $[31] !== storage || $[32] !== userId || $[33] !== workspaceId) {
    t15 = {
      activeViewNames,
      eligibilityContext,
      isVisualizationGuardActive,
      organizationId,
      setStorage,
      storage,
      userId,
      workspaceId
    };
    $[27] = activeViewNames;
    $[28] = eligibilityContext;
    $[29] = isVisualizationGuardActive;
    $[30] = organizationId;
    $[31] = storage;
    $[32] = userId;
    $[33] = workspaceId;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  const session = useTourSession(t15);
  let t16;
  if ($[35] !== session.activeTourId) {
    t16 = shouldFetchWorkspaceInviteMemberCount({
      activeTourId: session.activeTourId
    });
    $[35] = session.activeTourId;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  const shouldFetchInviteMemberCount = t16;
  let t17;
  if ($[37] !== workspaceId) {
    t17 = getWorkspaceUserCountQueryOptions(workspaceId);
    $[37] = workspaceId;
    $[38] = t17;
  } else {
    t17 = $[38];
  }
  const t18 = Boolean(workspaceId) && shouldFetchInviteMemberCount;
  let t19;
  if ($[39] !== t17 || $[40] !== t18) {
    t19 = {
      ...t17,
      enabled: t18,
      select: _temp3
    };
    $[39] = t17;
    $[40] = t18;
    $[41] = t19;
  } else {
    t19 = $[41];
  }
  const {
    data: workspaceUserCount,
    isSuccess: hasLoadedWorkspaceUserCount
  } = useQuery(t19);
  let t20;
  let t21;
  if ($[42] !== organizationId || $[43] !== userId) {
    t20 = function hydrateOnboardingToursStorage() {
      if (!organizationId || !userId) {
        return;
      }
      setStorage(readOnboardingToursStorage({
        organizationId,
        userId
      }));
    };
    t21 = [organizationId, userId];
    $[42] = organizationId;
    $[43] = userId;
    $[44] = t20;
    $[45] = t21;
  } else {
    t20 = $[44];
    t21 = $[45];
  }
  useEffect(t20, t21);
  let t22;
  let t23;
  if ($[46] !== dataProviders.length || $[47] !== hasLoadedWorkspaceUserCount || $[48] !== organizationId || $[49] !== userId || $[50] !== workspaceUserCount) {
    t22 = function persistObjectivesFromAppState() {
      if (!organizationId || !userId) {
        return;
      }
      setStorage(previous => {
        const nextStorage = {
          ...previous,
          objectives: {
            ...previous.objectives,
            hasDataProvider: deriveDataProviderObjective({
              providerCount: dataProviders.length
            }),
            hasInvitedMember: resolvePersistedInvitedObjective({
              memberCount: hasLoadedWorkspaceUserCount ? workspaceUserCount ?? 0 : null,
              previousHasInvitedMember: previous.objectives.hasInvitedMember,
              tourCompleted: Boolean(previous.tourRuns["invite-team-member"]?.completedAt)
            })
          }
        };
        writeOnboardingToursStorage({
          organizationId,
          userId,
          value: nextStorage
        });
        return nextStorage;
      });
    };
    t23 = [dataProviders.length, hasLoadedWorkspaceUserCount, organizationId, userId, workspaceUserCount];
    $[46] = dataProviders.length;
    $[47] = hasLoadedWorkspaceUserCount;
    $[48] = organizationId;
    $[49] = userId;
    $[50] = workspaceUserCount;
    $[51] = t22;
    $[52] = t23;
  } else {
    t22 = $[51];
    t23 = $[52];
  }
  useEffect(t22, t23);
  let t24;
  if ($[53] !== catalogPage || $[54] !== catalogQuery || $[55] !== eligibilityContext) {
    t24 = getCatalogPage({
      eligibilityContext,
      page: catalogPage,
      query: catalogQuery,
      tours: ALL_TOUR_DEFINITIONS
    });
    $[53] = catalogPage;
    $[54] = catalogQuery;
    $[55] = eligibilityContext;
    $[56] = t24;
  } else {
    t24 = $[56];
  }
  const catalogPageData = t24;
  const startTour = session.startTour;
  let t25;
  if ($[57] !== dataProviders.length || $[58] !== setCatalogOpen || $[59] !== startTour) {
    t25 = request => {
      setCatalogOpen(false);
      if (request.tourId === "delete-data-provider" && dataProviders.length === 0) {
        startTour({
          ...request,
          tourId: "add-data-provider-settings"
        });
        return;
      }
      startTour(request);
    };
    $[57] = dataProviders.length;
    $[58] = setCatalogOpen;
    $[59] = startTour;
    $[60] = t25;
  } else {
    t25 = $[60];
  }
  const wrappedStartTour = t25;
  let t26;
  let t27;
  if ($[61] !== eligibilityContext || $[62] !== isVisualizationGuardActive || $[63] !== organizationId || $[64] !== session || $[65] !== storage || $[66] !== userId || $[67] !== workspaceId) {
    t26 = function tryInitialPipelineAdvance() {
      if (!workspaceId || !organizationId || !userId || session.isTourActive || pipelineAttemptedRef.current) {
        return;
      }
      if (!shouldAttemptPipeline({
        isTourActive: session.isTourActive
      })) {
        return;
      }
      const advance = resolvePipelineAdvanceAction({
        pipelineContext: {
          canInvite: eligibilityContext.canInvite,
          isVisualizationGuardActive
        },
        storage,
        workspaceId
      });
      if (!advance) {
        return;
      }
      pipelineAttemptedRef.current = true;
      session.executeLaunch(advance);
    };
    t27 = [eligibilityContext, isVisualizationGuardActive, organizationId, session, storage, userId, workspaceId];
    $[61] = eligibilityContext;
    $[62] = isVisualizationGuardActive;
    $[63] = organizationId;
    $[64] = session;
    $[65] = storage;
    $[66] = userId;
    $[67] = workspaceId;
    $[68] = t26;
    $[69] = t27;
  } else {
    t26 = $[68];
    t27 = $[69];
  }
  useEffect(t26, t27);
  let t28;
  let t29;
  if ($[70] !== eligibilityContext || $[71] !== isVisualizationGuardActive || $[72] !== session || $[73] !== storage || $[74] !== workspaceId) {
    t28 = function retryPipelineWhenGuardActivates() {
      if (!workspaceId || session.isTourActive || !isVisualizationGuardActive) {
        return;
      }
      if (!shouldAttemptPipeline({
        isTourActive: session.isTourActive
      })) {
        return;
      }
      const advance_0 = resolvePipelineAdvanceAction({
        pipelineContext: {
          canInvite: eligibilityContext.canInvite,
          isVisualizationGuardActive
        },
        storage,
        workspaceId
      });
      if (advance_0?.tourId === "add-data-provider-guard") {
        session.executeLaunch(advance_0);
      }
    };
    t29 = [eligibilityContext, isVisualizationGuardActive, session, storage, workspaceId];
    $[70] = eligibilityContext;
    $[71] = isVisualizationGuardActive;
    $[72] = session;
    $[73] = storage;
    $[74] = workspaceId;
    $[75] = t28;
    $[76] = t29;
  } else {
    t28 = $[75];
    t29 = $[76];
  }
  useEffect(t28, t29);
  let t30;
  if ($[77] !== catalogOpen || $[78] !== catalogPage || $[79] !== catalogPageData || $[80] !== catalogQuery || $[81] !== session.abandonTour || $[82] !== session.activeTourId || $[83] !== session.isTourActive || $[84] !== session.notifyTourHostDismissed || $[85] !== setCatalogOpen || $[86] !== wrappedStartTour) {
    t30 = {
      abandonTour: session.abandonTour,
      activeTourId: session.activeTourId,
      catalogOpen,
      catalogPage,
      catalogPageData,
      catalogQuery,
      isTourActive: session.isTourActive,
      notifyTourHostDismissed: session.notifyTourHostDismissed,
      setCatalogOpen,
      setCatalogPage,
      setCatalogQuery,
      startTour: wrappedStartTour
    };
    $[77] = catalogOpen;
    $[78] = catalogPage;
    $[79] = catalogPageData;
    $[80] = catalogQuery;
    $[81] = session.abandonTour;
    $[82] = session.activeTourId;
    $[83] = session.isTourActive;
    $[84] = session.notifyTourHostDismissed;
    $[85] = setCatalogOpen;
    $[86] = wrappedStartTour;
    $[87] = t30;
  } else {
    t30 = $[87];
  }
  const contextValue = t30;
  let t31;
  if ($[88] !== session) {
    t31 = <TourJoyrideShell session={session} />;
    $[88] = session;
    $[89] = t31;
  } else {
    t31 = $[89];
  }
  let t32;
  if ($[90] !== canAccessProductToursCatalog) {
    t32 = canAccessProductToursCatalog ? <TourCatalogDialog /> : null;
    $[90] = canAccessProductToursCatalog;
    $[91] = t32;
  } else {
    t32 = $[91];
  }
  let t33;
  if ($[92] !== session.setShareViewTourUnavailableOpen || $[93] !== session.shareViewTourUnavailableOpen) {
    t33 = <ShareViewTourUnavailableDialog onOpenChange={session.setShareViewTourUnavailableOpen} open={session.shareViewTourUnavailableOpen} />;
    $[92] = session.setShareViewTourUnavailableOpen;
    $[93] = session.shareViewTourUnavailableOpen;
    $[94] = t33;
  } else {
    t33 = $[94];
  }
  let t34;
  if ($[95] !== children || $[96] !== contextValue || $[97] !== t31 || $[98] !== t32 || $[99] !== t33) {
    t34 = <OnboardingToursContext value={contextValue}>{children}{t31}{t32}{t33}</OnboardingToursContext>;
    $[95] = children;
    $[96] = contextValue;
    $[97] = t31;
    $[98] = t32;
    $[99] = t33;
    $[100] = t34;
  } else {
    t34 = $[100];
  }
  return t34;
}
function _temp3(response) {
  return response.count;
}
function _temp2(permission) {
  return permission.canEdit;
}
function _temp(view) {
  return view.name;
}
export function OnboardingToursProvider(t0) {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <VisualizationGuardTourSignalProvider><OnboardingToursRuntime>{children}</OnboardingToursRuntime></VisualizationGuardTourSignalProvider>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}